"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserValidator = exports.updateUserSchema = exports.createUserValidator = exports.createUserSchema = exports.getUserValidator = exports.getUserSchema = exports.changeMyPasswordValidator = exports.changeMyPasswordSchema = void 0;
const User_1 = require("../models/User");
const yup_custom_1 = require("../yup-custom");
exports.changeMyPasswordSchema = yup_custom_1.yup
    .object()
    .shape({
    currentPassword: yup_custom_1.yup.string().required(),
    newPassword: yup_custom_1.yup.string().required().min(8),
});
const changeMyPasswordValidator = async (body) => {
    return await exports.changeMyPasswordSchema.validate(body, { stripUnknown: true });
};
exports.changeMyPasswordValidator = changeMyPasswordValidator;
exports.getUserSchema = yup_custom_1.yup.object().shape({
    name: yup_custom_1.yup.string(),
    type: yup_custom_1.yup.string().enum(User_1.UserType),
});
const getUserValidator = async (body) => {
    return await exports.getUserSchema.validate(body, { stripUnknown: true });
};
exports.getUserValidator = getUserValidator;
const validatorBase = yup_custom_1.yup.object().shape({
    status: yup_custom_1.yup.string().enum(User_1.UserStatus).required(),
    email: yup_custom_1.yup.string().required(),
    name: yup_custom_1.yup.string().required(),
    permissions: yup_custom_1.yup.array().of(yup_custom_1.yup.string().required()).required(),
});
exports.createUserSchema = validatorBase.concat(yup_custom_1.yup.object().shape({}));
const createUserValidator = async (body) => {
    return await exports.createUserSchema.validate(body, { stripUnknown: true });
};
exports.createUserValidator = createUserValidator;
exports.updateUserSchema = validatorBase.concat(yup_custom_1.yup.object().shape({
    id: yup_custom_1.yup.number().required(),
}));
const updateUserValidator = async (body) => {
    return await exports.updateUserSchema.validate(body, { stripUnknown: true });
};
exports.updateUserValidator = updateUserValidator;
